import { jsx as _jsx } from "react/jsx-runtime";
import { Pill } from "../primitives/Pill";
const TONE = {
    owner: "indigo",
    manager: "accent",
    cashier: "neutral",
};
const LABEL = {
    owner: "Owner",
    manager: "Manager",
    cashier: "Cashier",
};
export function RoleBadge({ role }) {
    return _jsx(Pill, { tone: TONE[role], children: LABEL[role] });
}
//# sourceMappingURL=RoleBadge.js.map